// noinspection AllyPlainJsInspection

export const LOCAL_STORAGE_KEYS = {
  LANG: 'luba.uilang',
  CURRENT_CHECKPOINT_USER: 'luba.currentCheckpointUser',
  BGCHECK(applicationId) {
    return `luba.backgroundCheck.${applicationId}`;
  },
  BGCHECK_UPLOADED_FILE(applicationId) {
    return `${this.BGCHECK(applicationId)}.uploadedFile`;
  },
  BGCHECK_WIZARD_STEP(applicationId) {
    return `${this.BGCHECK(applicationId)}.wizardStep`;
  },
  WIZARD_STEP(applicationId) {
    return `${this.BGCHECK(applicationId)}.holderWizardStep`;
  },
};

export const HOLDER_DRAFT_TTL_DAYS = 10; // must equal lis-back system.cardHolder.linkValidityDays

export const SESSION_STORAGE_KEYS = {
  ACTIVE_ROLE: 'lis.activeRole',
};

// Custom request header names understood by the backend. X-Org-View is set only on the
// org-view page's dedicated endpoints, never in the global prepareHeaders.
export const HEADER_NAMES = {
  CSRF: 'X-XSRF-TOKEN',
  ACTIVE_ROLE: 'X-Active-Role',
  ORG_VIEW: 'X-Org-View',
};

export const UserGroups = {
  Admins: 'Admins',
  Managers: 'Managers',
  PartnerManagers: 'PartnerManagers',
  Users: 'Users',
  Iok: 'IOK',
  TeamManager: 'TeamManager',
  GuestPermit: 'GuestPermit',
  Instructor: 'Instructor',
};

// Highest privilege first, exactly mirroring backend AuthConfiguration.RoleSort (TASK-119).
// GuestCheckpoint (a cookie-based guest-desk identity) and Checkpoint (a kiosk-only role for
// another app) aren't meaningfully ranked there at all (RoleSort falls through to int.MaxValue
// for both), and neither reaches lis-front's MSAL role handling regardless.
export const ROLE_PRIORITY = [
  UserGroups.Admins,
  UserGroups.Iok,
  UserGroups.Managers,
  UserGroups.TeamManager,
  UserGroups.PartnerManagers,
  UserGroups.GuestPermit,
  UserGroups.Instructor,
];

// Roles admitted to the /gc guest-checkpoint desk (mirrors backend GuestPermitOperatorPolicy,
// minus GuestCheckpoint itself, which never reaches this MSAL role handling). Highest privilege
// first, same as ROLE_PRIORITY — see active-role-utils.getGcRole and mixedAuthLubaApi.js.
export const GC_ROLES = [UserGroups.Admins, UserGroups.GuestPermit];

export const LANG = {
  EN: 'en',
  ET: 'et',
};

export const VALIDATION = {
  email: 'validation.common.error.invalid_email_address',
  required: 'validation.common.error.value_required',
};

export const SecondaryApplicationReasons = {
  PeriodExtension: 'periodExtension',
  CardholderDataChange: 'cardholderDataChange',
  PermissionChange: 'permissionChange',
  NewAirport: 'newAirport',
  CardLost: 'cardLost'
};

export const ApplicationTypes = {
  Primary: 'Primary',
  Secondary: 'Secondary',
  All: 'All'
};

export const ApplicationSearchSortBy = {
  Nr: 0,
  Firstname: 1,
  Lastname: 2,
  Company: 3,
  Code: 4,
}

export const PermitSearchSortBy = {
  Nr: 1,
  ApplicationNr: 2,
  CardHolder: 3,
  ValidUntil: 4,
  Company: 5,
}

export const DashboardActionStyle = { padding: '4px 8px', borderRadius: 0 };

export const TallinnAirportCompanyNames = [
  'AS Tallinna Lennujaam',
  'Tallinna Lennujaam AS',
  'Airport City AS',
  'AS Airport City',
  'Tallinn Airport GH AS',
  'Tallinn Airport GH',
  'AS Tallinn Airport GH'
];
export const HRDepartments = ['Inimeste ja organisatsioonikultuuri osakond'];

export const SignTypes = {
  IdCard: 'IdCard',
  SmartId: 'SmartId',
  MobileId: 'MobileId',
};